// This is an auto-generated file. Please do not edit directly.
// For instructions on editing source .json files, please see:
// https://git.hubteam.com/HubSpot/UIComponents/tree/master/HubStyleTokens
// ***********************************************************************
export const BASE_FONT_COLOR = '#33475b';
export const BASE_LINK_COLOR = '#0091ae';
export const BASE_LINK_ACTIVE_COLOR = '#7fd1de';
export const BASE_LINK_HOVER_COLOR = '#007a8c';
export const BASE_SELECTION_BACKGROUND_COLOR = '#eaf0f6';
export const BASE_BACKGROUND_COLOR = '#ffffff';
export const BASE_BACKGROUND_COLOR_MEDIUM = '#f5f8fa';
export const BASE_BACKGROUND_COLOR_DARK = '#33475b';
export const BASE_FONT_CONTRAST_COLOR = '#ffffff';
export const BASE_SHADOW_COLOR = '#000000';
export const BUTTON_DISABLED_BACKGROUND_COLOR = '#eaf0f6';
export const CARD_SHADOW_COLOR = '#2d3e50';
export const FLOATING_BUTTON_GROUP_ITEM_BACKGROUND_COLOR = '#425b76';
export const FLOATING_BUTTON_GROUP_ITEM_BORDER_COLOR = '#516f90';
export const FLOATING_BUTTON_GROUP_ITEM_COLOR = '#ffffff';
export const FLOATING_BUTTON_GROUP_ITEM_HOVER_BACKGROUND_COLOR = '#516f90';
export const FLOATING_BUTTON_GROUP_ITEM_SELECTED_BACKGROUND_COLOR = '#33475b';
export const CODE_BACKGROUND_COLOR = '#eaf0f6';
export const CODE_FOREGROUND_COLOR = '#33475b';
export const CODE_BLOCK_BACKGROUND_COLOR = '#f5f8fa';
export const CONNECTED_STEP_SELECTED_COLOR = '#ff7a59';
export const CONNECTED_STEP_UNSELECTED_COLOR = '#cbd6e2';
export const DARK_LINK_COLOR = '#ffffff';
export const DARK_LINK_ACTIVE_COLOR = '#eaf0f6';
export const DARK_LINK_HOVER_COLOR = '#7fd1de';
export const DARK_LINK_ICON_COLOR = '#ffffff';
export const BRIGHT_LINK_COLOR = '#33475b';
export const BRIGHT_LINK_ACTIVE_COLOR = '#33475b';
export const BRIGHT_LINK_HOVER_COLOR = '#33475b';
export const BRIGHT_LINK_ICON_COLOR = '#425b76';
export const DANGER_LINK_COLOR = '#f2545b';
export const DANGER_LINK_ACTIVE_COLOR = '#d94c53';
export const DANGER_LINK_HOVER_COLOR = '#d94c53';
export const MENTION_LINK_COLOR = '#425b76';
export const MENTION_LINK_ACTIVE_COLOR = '#33475b';
export const MENTION_LINK_HOVER_COLOR = '#33475b';
export const DROPDOWN_BACKGROUND_COLOR = '#ffffff';
export const DROPDOWN_BORDER_COLOR = '#cbd6e2';
export const DROPDOWN_SELECTED_BACKGROUND_COLOR = '#e5f5f8';
export const DROPDOWN_SEARCH_BACKGROUND_COLOR = '#ffffff';
export const DROPDOWN_SEARCH_WRAPPER_BACKGROUND_COLOR = '#eaf0f6';
export const DROPDOWN_CARET_COLOR = '#00a4bd';
export const TOOLBAR_DARK_BACKGROUND_COLOR = '#253342';
export const TOOLBAR_DARK_FOREGROUND_COLOR = '#ffffff';
export const EDITOR_LAYOUT_SHADOW_COLOR = '#516f90';
export const FORM_CONTROL_BACKGROUND_COLOR = '#f5f8fa';
export const FORM_CONTROL_FOREGROUND_COLOR = '#33475b';
export const FORM_CONTROL_BORDER_COLOR = '#cbd6e2';
export const FORM_CONTROL_READONLY_BACKGROUND_COLOR = '#eaf0f6';
export const FORM_CONTROL_READONLY_BORDER_COLOR = '#eaf0f6';
export const FORM_COPYABLE_BACKGROUND_COLOR = '#ffffff';
export const FORM_DISABLED_COLOR = '#cbd6e2';
export const FORM_DISABLED_BACKGROUND_COLOR = '#eaf0f6';
export const FORM_PLACEHOLDER_COLOR = '#7c98b6';
export const FORM_STATIC_LABELS_BACKGROUND_COLOR = '#eaf0f6';
export const FORM_STATIC_LABELS_COLOR = '#7c98b6';
export const FORM_TOGGLE_BACKGROUND_COLOR = '#ffffff';
export const FORM_TOGGLE_HOVER_BACKGROUND_COLOR = '#eaf0f6';
export const FORM_TOGGLE_BORDER_COLOR = '#cbd6e2';
export const FORM_TOGGLE_DISABLED_FOREGROUND_COLOR = '#99acc2';
export const FORM_TOGGLE_HOVER_FOREGROUND_COLOR = '#0091ae';
export const FORM_TOGGLE_ICON_COLOR = '#99acc2';
export const FORM_TOGGLE_SELECTED_BACKGROUND_COLOR = '#ffffff';
export const FORM_TOGGLE_SELECTED_FOREGROUND_COLOR = '#00a4bd';
export const HR_BORDER_COLOR = '#dfe3eb';
export const ICON_DEFAULT_COLOR = '#7c98b6';
export const MODAL_BACKGROUND_COLOR = '#ffffff';
export const MODAL_CLOSE_BUTTON_FOREGROUND_COLOR = '#99acc2';
export const MODAL_DANGER_FOREGROUND_COLOR = '#ffffff';
export const MODAL_FOOTER_BACKGROUND_COLOR = '#ffffff';
export const MODAL_HEADER_BACKGROUND_COLOR = '#00bda5';
export const MODAL_HEADER_FOREGROUND_COLOR = '#ffffff';
export const MODAL_HEADER_START_GRADIENT = '#00a4bd';
export const MODAL_HEADER_MIDDLE_GRADIENT = '#00afb2';
export const MODAL_HEADER_END_GRADIENT = '#00bda5';
export const MODAL_HEADING_INVERTED_FOREGROUND_COLOR = '#ffffff';
export const MODAL_UPGRADES_FOREGROUND_COLOR = '#ffffff';
export const MODAL_UPGRADES_END_GRADIENT = '#ff8f59';
export const MODAL_UPGRADES_START_GRADIENT = '#ff7a59';
export const MODAL_SUCCESS_BACKGROUND_COLOR = '#00bda5';
export const MODAL_SUCCESS_FOREGROUND_COLOR = '#ffffff';
export const PAGINATION_ACTIVE_BACKGROUND_COLOR = '#cbd6e2';
export const PAGINATION_HOVER_BACKGROUND_COLOR = '#eaf0f6';
export const PAGINATION_SELECTED_BACKGROUND_COLOR = '#e5f5f8';
export const PAGINATION_SELECTED_BORDER_COLOR = '#7fd1de';
export const SELECTABLE_BOX_BORDER_COLOR = '#7fd1de';
export const SELECTABLE_BOX_SHADOW_COLOR = 'rgba(0, 163, 189, .3)';
export const SELECTABLE_BOX_SELECTED_BORDER_COLOR = '#00a4bd';
export const SELECTABLE_BOX_SELECTED_BACKGROUND_COLOR = '#e5f5f8';
export const SIDENAV_FOREGROUND_COLOR = '#33475b';
export const SIDENAV_HOVERED_BACKGROUND_COLOR = '#e5f5f8';
export const SIDENAV_SELECTED_BACKGROUND_COLOR = '#e5f5f8';
export const SIDENAV_SELECTED_BORDER_COLOR = '#00a4bd';
export const TABLE_SORT_ARROW_COLOR = '#cbd6e2';
export const TABLE_SORT_ARROW_SELECTED_COLOR = '#00a4bd';
export const LOADING_INACTIVE_COLOR = '#cbd6e2';
export const LOADING_DEFAULT_COLOR = '#00a4bd';
export const OVERLAY_BACKGROUND_COLOR = '#2d3e50';
export const OVERLAY_BACKGROUND_COLOR_TRANSLUCENT = 'rgba(45, 62, 80, 0.79)';
export const PANEL_CLOSE_BUTTON_FOREGROUND_COLOR = '#ffffff';
export const PANEL_FOOTER_BACKGROUND_COLOR = '#f5f8fa';
export const PANEL_FOOTER_BORDER_COLOR = '#cbd6e2';
export const PANEL_SHADOW_COLOR = 'rgba(66, 91, 118, 0.21)';
export const TABLE_BACKGROUND_COLOR = '#ffffff';
export const TABLE_BORDER_COLOR = '#dfe3eb';
export const TABLE_HEADER_BACKGROUND_COLOR = '#f5f8fa';
export const TABLE_ROW_HOVER_BACKGROUND_COLOR = '#f5f8fa';
export const TABLE_SORTABLE_HOVER_BACKGROUND_COLOR = '#e5f5f8';
export const TABLE_SORTABLE_HOVER_ICON_COLOR = '#7c98b6';
export const TABLE_SORTABLE_SORTED_BACKGROUND_COLOR = '#eaf0f6';
export const TAG_AVATAR_BORDER_COLOR = '#7fd1de';
export const TEMPLATE_SECTION_DIVIDER_BORDER_COLOR = '#cbd6e2';
export const TOOLTIP_FOREGROUND_COLOR = '#ffffff';
export const TOOLTIP_DANGER_BACKGROUND_COLOR = '#f2545b';
export const TOOLTIP_DEFAULT_BACKGROUND_COLOR = '#425b76';
export const TOOLTIP_LONGFORM_BACKGROUND_COLOR = '#ffffff';
export const TOOLTIP_LONGFORM_CLOSE_BUTTON_COLOR = '#0091ae';
export const TOOLTIP_LONGFORM_FOCUS_COLOR = '#00a4bd';
export const WIZARD_HEADER_BACKGROUND_COLOR = '#ffffff';
export const WIZARD_HEADER_BORDER_COLOR = '#cbd6e2';
export const DEVICE_FRAME_COLOR = '#7c98b6';